import React from 'react';

const LOGO_HORIZONTAL =
  'https://customer-assets.emergentagent.com/job_axaca-logistics/artifacts/2oawsmg9_1.png';
const LOGO_SQUARE_BLUE =
  'https://customer-assets.emergentagent.com/job_axaca-logistics/artifacts/7ayuedtn_5.png';

// Renders the AXACA wordmark with brand styling on dark backgrounds.
// The official logo PNG has dark text on white, which doesn't work well
// over black, so we recreate the wordmark using brand typography while
// using the official square blue mark as the icon.
export const Logo = ({ className = '' }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src={LOGO_SQUARE_BLUE}
        alt="Axaca"
        className="h-10 w-10 rounded-lg object-cover"
      />
      <div className="flex flex-col leading-none">
        <span
          className="text-white font-extrabold tracking-[0.2em] text-base md:text-[17px]"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          AXACA
        </span>
        <span className="text-zinc-400 text-[9.5px] tracking-[0.32em] mt-1 font-medium">
          SOLUTIONS <span className="text-[#5b8def]">|</span> LOGISTIQUES
        </span>
      </div>
    </div>
  );
};

export const LogoMark = ({ className = '' }) => (
  <img
    src={LOGO_SQUARE_BLUE}
    alt="Axaca"
    className={`rounded-2xl ${className}`}
  />
);

export const BigLogo = () => (
  <img
    src={LOGO_HORIZONTAL}
    alt="Axaca Solutions Logistiques"
    className="h-20 w-auto rounded-lg bg-white p-2"
  />
);
